<div class="wrapper">
  <div class="loader"></div>
  Loading...
</div>
